export default "__VITE_ASSET__BLDTsw05__"